import recentSearchesStorageKeysCE from '~/filtered_search/recent_searches_storage_keys';

export default {
  ...recentSearchesStorageKeysCE,
  epics: 'epics-recent-searches',
};
